import React from 'react';

export const PaginationBar = ({ page, pageSize, total, onChange }) => {
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);
  const lastPage = Math.max(1, Math.ceil(total / pageSize));
  const btn = 'px-3 py-1.5 text-sm border rounded-md disabled:opacity-40 hover:bg-slate-50';
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 p-4 border-t" data-testid="payment-pagination">
      <span className="text-sm text-slate-600" data-testid="payment-pagination-summary">
        Showing {start}–{end} of {total}
      </span>
      <div className="flex items-center gap-2">
        <select
          data-testid="payment-page-size"
          value={pageSize}
          onChange={(e) => onChange({ page: 1, page_size: Number(e.target.value) })}
          className="border rounded-md px-2 py-1.5 text-sm"
        >
          {[50, 100, 500].map((n) => <option key={n} value={n}>{n} / page</option>)}
        </select>
        <button type="button" className={btn} data-testid="payment-page-prev" disabled={page <= 1}
          onClick={() => onChange({ page: page - 1 })}>Prev</button>
        <span className="text-sm text-slate-500">{page} / {lastPage}</span>
        <button type="button" className={btn} data-testid="payment-page-next" disabled={page >= lastPage}
          onClick={() => onChange({ page: page + 1 })}>Next</button>
      </div>
    </div>
  );
};
